import GqlData from "../gql_data";

const videoUrlQuery = (id: number, siteId: number): GqlData => {
    return {
        query: `query VideoUrl($id: Int!, $siteId: Int)
            {
                videoUrl (
                    id: $id
                    siteId: $siteId
                ) {
                    url info infoCode license
                }
            }`,
        variables: { id, siteId }
    }
};

const epgHlsUrlQuery = (channel: string, chunkStart: number, chunkEnd: number): GqlData => {
    return {
        query: `query EpgHlsUrl($channel: String! $chunkStart: Int! $chunkEnd: Int!)
            {
                epgHlsUrl (
                    channel: $channel
                    chunkStart: $chunkStart
                    chunkEnd: $chunkEnd
                ) {
                    url breaks { from to }
                }
            }`,
        variables: { channel, chunkStart, chunkEnd }
    }
};

export { videoUrlQuery, epgHlsUrlQuery }